import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
    MerchantsOverviewAdminQueryQuery, 
    QueryMerchantsOverviewAdminArgs 
} from "../../../../../schemaTypes";

export const merchantsOverviewAdminQuery = gql`
  query MerchantsOverviewAdminQuery(
    $duration: String!
  ) {
    merchantsOverviewAdmin(
      duration: $duration 
    ) {
        registeredMerchants
        activeMerchants
        inActiveMerchants
        totalCurrentBalance
        totalWithdrawals
    }
  }
`;

export interface WithMerchantsOverviewAdmin {
  registeredMerchants: number;
  activeMerchants: number;
  inActiveMerchants: number;
  totalCurrentBalance: number;
  totalWithdrawals: number;
}

interface Props {
  variables: QueryMerchantsOverviewAdminArgs;
  children: (data: WithMerchantsOverviewAdmin) => React.ReactElement | null;
}

export const MerchantsOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    MerchantsOverviewAdminQueryQuery,
    QueryMerchantsOverviewAdminArgs
  >(merchantsOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const registeredMerchants = data?.merchantsOverviewAdmin?.registeredMerchants|| 0;
  const activeMerchants = data?.merchantsOverviewAdmin?.activeMerchants || 0;
  const inActiveMerchants = data?.merchantsOverviewAdmin?.inActiveMerchants || 0;
  const totalCurrentBalance = data?.merchantsOverviewAdmin?.totalCurrentBalance || 0;
  const totalWithdrawals = data?.merchantsOverviewAdmin?.totalWithdrawals || 0;


  return children({
        registeredMerchants,
        activeMerchants,
        inActiveMerchants,
        totalCurrentBalance,
        totalWithdrawals
  });
};